/**
 * Pagination constants
 */

/** Default number of items per page for list views */
export const DEFAULT_PAGE_SIZE = 20;

/** Default number of items per page for search results */
export const SEARCH_PAGE_SIZE = 20;

/** Maximum number of issues to fetch at once */
export const MAX_ISSUES_LIMIT = 100;

/** Default number of authors to fetch per page */
export const AUTHORS_PAGE_SIZE = 20;

/** Stale time for queries in milliseconds (30 seconds) */
export const DEFAULT_STALE_TIME = 30000;

/** Stale time for issue queries in milliseconds (60 seconds) */
export const ISSUE_STALE_TIME = 60000;
